<script>
import {
  StoriesWithHashtagPageElementMixin,
} from "%/dynamic-component-editor/standard-pages/stories-with-hashtag-page/stories-with-hashtag-page-element-mixin";
import { camelToTitleCase } from "@bloglovin/vue-framework";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";

export default {
  name: "HashtagTitle",
  extends: TextElement,
  mixins: [StoriesWithHashtagPageElementMixin],
  elementPanelSettings: {
    displayName: "Hashtag Title",
    displayIcon: "pencil",
    elementGroup: "storiesWithHashtagElements",
    elementType: "element",
  },
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      const title = this.editMode ? "Hashtag Title" : this.hashtagEntityId;
      return camelToTitleCase(String(title ?? ""));
    },
  },
};
</script>
